var curry = require('curry')
var scrollTo = require('../../scrollTo.js')
var ease = require('ease-component')
var selectItem = require('./selectItem.js')

var onItemClick = (map, item) => {
	var contRect = map.container.getElement().parentNode.getBoundingClientRect()
	scrollTo(window.scrollY + contRect.top, 300, ease.inCube, () => '')
	selectItem(map, item)
}

module.exports = function bindItemClickHandler(map, item) {
	item.el.querySelector('.contacts__city a').addEventListener('click', (evt) => onItemClick(map, item))
	return item
}


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/contacts/fn/bindItemClickHandler.js
 **/